import type { VehicleImage, VehicleImages } from "@repo/types";

export { VehicleNumberEnum } from "@repo/types/generated/enums";

import type { Delivery } from "./delivery.types";

export enum VehicleType {
  GAS = "GAS",
  HYBRID = "HYBRID",
  ELECTRIC = "ELECTRIC",
}

export type Vehicle = {
  id?: number;
  vin?: string;
  vehicleCode: string;
  marque: string;
  model: string;
  type: VehicleType;
  carType?: string;
  deliveryId?: string;
  delivery?: Delivery;
  isDelivered?: boolean;
  toRetrieve?: boolean;
  imagesBefore?: DamagedCarImages;
  imagesAfter?: DamagedCarImages;
  garageImages?: CarImages;
  essenceBefore?: number;
  essenceAfter?: number;
  mileageBefore?: number;
  mileageAfter?: number;
  pickedUpAt?: Date;
  actualPickedUpAt?: Date;
  deliveredAt?: Date;
};

export type CarImages = {
  photo1: string;
  photo2: string;
  photo3: string;
  photo4: string;
  photo5: string;
  photo6: string;
};

export type ImageValue = VehicleImage;
export type DamagedCarImages = VehicleImages;
